<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("content.amnreportsms") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-3 mt-0">
                <fieldset>
                  <div class="item">
                    <material-checkbox v-model="time" :checked="time" name="autoSelect" @change="onserachDate">
                      <label class="form-label m-0">{{ $t("content.sdate") }}</label>
                    </material-checkbox>
                    <VueDatePicker
                      v-model="start_date"
                      :format="format"
                      auto-apply
                      :teleport="true"
                      :max-date="new Date().setHours(23, 59, 59)"
                      :enable-time-picker="false"
                      month-name-format="long"
                      :clearable="false"
                      fluid
                      :text-input="textInputOptions"
                      :disabled="!time"
                    />
                  </div>
                </fieldset>
              </div>
              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker
                  v-model="end_date"
                  :format="format"
                  auto-apply
                  :teleport="true"
                  :max-date="new Date().setHours(23, 59, 59)"
                  :enable-time-picker="false"
                  month-name-format="long"
                  :clearable="false"
                  fluid
                  :text-input="textInputOptions"
                  :disabled="!time"
                />
              </div>
              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                <material-input
                  type="text"
                  v-model="tk_search"
                  :placeholder="$t('content.amnticketnoex')"
                />
              </div>
              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.names") }}</label>
                  <div class="input-group">
                    <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                      readonly />
                    <button class="btn btn-primary" type="button" @click="openDialogCus">
                      <i class="material-icons material-symbols-outlined">search</i>
                    </button>
                    <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                      data-bs-target="#searchNameModal" v-show="false">
                    </button>
                  </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-end align-items-center gap-2">
                <material-button color="primary" class="mb-3" 
                  :disabled="(!time && tk_search === '' && cusName_search === '') || (time && start_date > end_date)"
                  @click="searchBtn">
                  <i class="material-icons material-symbols-outlined">search</i>
                  {{ $t("buttons.sear") }}
                </material-button>
                <material-button color="danger" class="mb-3" @click="cancelBtn">
                  <i class="material-icons material-symbols-outlined">close</i>
                  {{ $t("buttons.canc") }}
                </material-button>
              </div>
            </div>

            <hr />

            <div class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center">{{ $t("content.amnsmsdate") }}</th>
                      <th class="text-center">{{ $t("content.ticketno") }}</th>
                      <th class="text-center">{{ $t("content.amnshopname") }}</th>  
                      <th class="text-center">{{ $t("content.cmobile") }}</th>
                      <th class="text-center">{{ $t("content.amnsmsservice") }}</th>
                      <th class="text-center">{{ $t("content.amnnotified") }}</th>
                      <th class="text-center">{{ $t("content.status") }}</th>
                      <th class="text-center">{{ $t("content.amnretry") }}</th>
                      <th class="text-center">{{ $t("content.note") }}</th>
                      <th class="text-center">{{ $t("content.act") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="listdata.length === 0">
                      <td colspan="12" class="text-center py-4 text-sm text-secondary">
                        {{ $t("content.amnnodata") }}
                      </td>
                    </tr>
                    <tr v-for="(row, index) in listdata" :key="row.uid">
                      <td class="text-sm font-weight-normal border-0 text-center">
                        {{ (currentPage - 1) * perPage + index + 1 }}
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center" style="white-space: nowrap">
                        {{ formatDatetime(row.notifyDate) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        <span style="font-family: monospace; font-weight: 700">
                          {{ row.refNumber || "—" }}
                        </span>
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center">
                        {{ row.content && row.content.messages ? row.content.messages.shopName : "—" }}
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center" style="font-family: monospace">
                        {{ row.content && row.content.recipients ? row.content.recipients.join(", ") : "—" }}
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center">
                        {{ row.content ? row.content.service.toUpperCase() : "—" }}
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center">
                        <span v-if="!row.notified">{{ $t("content.amnstatuspending") }}</span>
                        <span v-else>{{ $t("content.amnnotifiedyes") }}</span>
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center">
                        <span v-if="!row.notified">{{ $t("content.amnstatuspending") }}</span>
                        <span v-else-if="row.success">{{ $t("content.amnsuccessyes") }}</span>
                        <span v-else>{{ $t("content.amnsuccessno") }}</span>
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center">
                        {{ row.retryCount }}
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center" style="color: #f44335">
                        {{ row.failedReason || "—" }}
                      </td>
                      <td class="text-sm font-weight-normal border-0 text-center">
                        <material-button
                          color="primary"
                          variant="outline"
                          class="rounded-circle"
                          :title="$t('content.amnresend')"
                          :disabled="(row.notified && row.success) || row.notifyChannel !== 'LINE'"
                          @click="onResend(row)"
                        >
                          <i class="material-icons material-symbols-outlined">send</i>
                        </material-button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                        <tr>
                          <td colspan="13" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="totalRows > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate
                      v-model="currentPage"
                      :total-items="totalRows"
                      :items-per-page="perPage"
                      @click="onClickHandler"
                    />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Search Customer Dialog -->
      <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                <i class="material-icons material-symbols-outlined">close</i>
              </button>
            </div>

            <div class="modal-body">
              <div class="preview-table">
                <section class="panel">
                  <table class="table table-striped table-responsive">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{{ $t("content.cnameth") }}</th>
                        <th>{{ $t("content.cnameen") }}</th>
                        <th>{{ $t("content.docno") }}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="row-search">
                        <td></td>
                        <td>
                          <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                        </td>
                        <td>
                          <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                        </td>
                        <td>
                          <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                        </td>
                        <td>
                          <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                            data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                            :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                            @click="loadCustomerListApi">
                            <i class="material-icons material-symbols-outlined">search</i>
                          </material-button>
                        </td>
                      </tr>
                      <tr v-for="(row, index) in customerlist" :key="index" @click="selectCustomer(row)">
                        <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                        <td>{{ row.nameTh }}</td>
                        <td>{{ row.nameEn }}</td>
                        <td colspan="2">{{ row.docNumber }}</td>
                      </tr>
                      <tr v-if="customerlist.length === 0">
                        <td colspan="5" class="text-sm font-weight-normal">
                          <p style="text-align: center">No Record Found</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>

            <div class="modal-footer">
              <pre></pre>
              <div style="display: flex; justify-content: flex-end">
                <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                  <div class="project-container">
                    <div class="example-one">
                      <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                        :items-per-page="perPageC" @click="onClickHandlerC" />
                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import moment from "moment";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import ExampleFive from "@/examples/ExampleOne";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue"

import { useSmsNotificationStore } from "@/stores/smsnotification";
import { useCustomerStore } from "@/stores/customer";
import { useCashAccountStore } from '@/stores/cashaccount'


const { t } = useI18n();
const swal = inject("$swal");

const store = useSmsNotificationStore();
const storecus = useCustomerStore()
const storeca = useCashAccountStore()


const loading = ref(false);
const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const tk_search = ref("");
const currentPage = ref(1);
const perPage = ref(20);
const totalRows = ref(1);
const totalRows_s = ref('');
const listdata = ref([]);

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();
const customerlist = ref([])
const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')
const cusUid_search = ref('');
const cusName_search = ref('');
const shop_detail = ref({})
const time = ref(false);


const format = (date) => moment(String(date)).local().format("DD/MM/YYYY");
const textInputOptions = { format: "dd/MM/yyyy" };

function formatDatetime(value) {
  if (value) return moment(String(value)).local().format("DD/MM/YYYY HH:mm");
  return "—";
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

const getshopInfo = async (val) => {
  shop_detail.value = {}
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data
      }
    }
  }
}

getshopInfo()

async function fetchData() {
  totalRows_s.value = ''
  let sd = ''
  let ed = ''
  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DD')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DD')
  }
  const payload = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: tk_search.value.trim(),
    cusUid: cusUid_search.value.trim(),
    notifyDateGe: sd,
    notifyDateLe: ed,
  };

  try {
    const response = await store.listFetch(payload);
    if (response && response.status === 200 && response.data.rtnDesc === "success") {
      let rows = response.data.data.list || [];
      listdata.value = rows;
      totalRows.value = response.data.data.ext ? response.data.data.ext.total : rows.length;
      totalRows_s.value = formatNumberString(listdata.value.length)
    }
  } finally {
    loading.value = false;
  }
}

function searchBtn() {
  currentPage.value = 1;
  fetchData();
}

const onserachDate = () => {
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
};

function cancelBtn() {
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
  tk_search.value = "";
  listdata.value = [];
  totalRows.value = 0;
  currentPage.value = 1;
  totalRows_s.value = ''
  cusUid_search.value = '';
  cusName_search.value = '';
  time.value = false
}

function onClickHandler() {
  fetchData();
}

const onClickHandlerC = () => {
  updatePaginationC()
};

async function onResend(row) {
  try {
    const response = await store.resend(row.uid);
    if (response && response.status === 200 && response.data.rtnDesc === "success") {
      swal(t("content.amnresendsuccess"), "", "success");
      fetchData();
    } else {
      swal(t("content.amnresend"), response.data.rtnDesc, "error");
    }
  } catch (e) {
    swal(t("content.amnresend"), e.message, "error");
  }
}


async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}


async function selectCustomer(item) {
  // console.log('selectCusAf : ' + JSON.stringify(item));
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gap-2 {
  gap: 0.5rem;
}
</style>
